import styled from 'styled-components'

export const StyledFitmentWrapper = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  border-radius: 4px;
  border: 1.5px solid #FFCD05;
  background: #FFFAE6;
  position: relative;
`
export const StyledRequireVehicleWrapper = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1.5px solid #FFCD05;
  background: #FFFAE6;
  position: relative;
`

export const StyledGuaranteeFitWrapper = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1.5px solid #527A36;
  background: #F4F8F2;
  position: relative;
`

export const StyledDoesNotFitWrapper = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1.5px solid #CC3333;
  background: #FDEAE9;
  position: relative;
`

export const StyledUniversalFitWrapper = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1.5px solid #3E3E47;
  background: #FFFFFF;
  position: relative;
`

export const StyledIconContainer = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 4px;
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
`

export const StyledFitmentInfoContainer = styled.div`
  display: block;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;

  div {
    display: flex;
    gap: 8px;
  }
`

export const StyledFitmentLabel = styled.p`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 165%;
  margin: 0;
`

export const StyledGuaranteedFit = styled.p`
  color: #496E30;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 165%;
  margin: 0;
  display: inline-block;
`

export const StyledDoesNotFit = styled.p`
  color: #CC3333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 165%;
  margin: 0;
  display: inline-block;
`

export const StyledUniversalFit = styled.p`
  color: #5E5E65;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 165%;
  margin: 0;
  display: inline-block;
`

export const StyledFitmentVehicle = styled.p`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 165%;
  margin: 0;
  display: inline-block;
`

export const StyledFitmentCTA = styled.button`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
  border: none;
  padding: 0;
  background: #FDEAE9;
  cursor: pointer;
`
